// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__2LKOP","logo":"Navbar_logo__3dTMd","navLinks":"Navbar_navLinks__260xz","lastDiv":"Navbar_lastDiv__1uMcx","downloadBtn":"Navbar_downloadBtn__3ODB1"};